<template>
  <div class="detalle-servicio-panel">
    <DxTabPanel height="95%" tabs-position="top" icon-position="left" :defer-rendering="false">
      <DxItem 
        v-for="marco in marcosComisiones" 
        :key="marco.Id" 
        :title="marco.Denominacion" 
        class="tab-item" 
        :disabled="false" 
      >
        <servicio-energia-tab-comisiones-marco 
          :id-servicio="(model as DetailServicioEnergiaModel).Id || ''" 
          :id-marco="marco.Id" 
          :is-edit-mode="isEditMode" 
          :ref="addTabRef">
        </servicio-energia-tab-comisiones-marco>
      </DxItem>
    </DxTabPanel>
  </div>
</template>

<script setup lang="ts">
import ServicioEnergiaTabComisionesMarco from '@/components/servicios-energia/base/ServicioEnergiaTabComisionesMarco.vue';
import { ref } from 'vue';
import { type CreateServicioEnergiaModel, type DetailServicioEnergiaModel, type SelectBoxGuidEntityModel } from '@/.shared/.api';
import DxTabPanel, { DxItem } from 'devextreme-vue/tab-panel';
import { useApi } from '@/.shared/.api/integration';
import { onMounted } from 'vue';

const api = useApi();
const tabComisionesMarco = ref<InstanceType<typeof ServicioEnergiaTabComisionesMarco>[]>([]);
const marcosComisiones = ref<SelectBoxGuidEntityModel[]>([]);

const addTabRef = (el: any) => {
  if (el) {
    tabComisionesMarco.value.push(el);
  }
};

const props = defineProps({
  model: {
    type: Object as () => DetailServicioEnergiaModel | CreateServicioEnergiaModel,
    required: true
  },
  isEditMode: {
    type: Boolean,  
    required: true
  },
});

onMounted(async () => {
  marcosComisiones.value = await api.callStandardApi("getMarcosComisionesList", {showLoading: false});
});

defineExpose({
  getComisiones: () => {
    const comisiones: any[] = [];
    for (const tab of tabComisionesMarco.value) {
      const tabComisiones = tab.getComisiones();
      if (tabComisiones) {
        const comisionesConMarco = tabComisiones.map(comision => ({
          ...comision,
          idMarco: tab.idMarco
        }));
        comisiones.push(...comisionesConMarco);
      }
    }
    return comisiones;
  },
});

</script>